// @ts-nocheck
import { motion } from 'framer-motion';
import { YStack, XStack, Text } from 'tamagui';
import { Container } from './Container';
import { Eyebrow, ConnectorMark } from './Eyebrow';
import { useIsMobile } from '../hooks/useIsMobile';

const MotionDiv = motion.div;

/**
 * The closing sequence: a vertical rule descending through a boxed mark, a boxed
 * label, and the final statement, each block interrupting the line it hangs on.
 *
 * The device is architectural drafting — a centre line with elements dimensioned
 * off it. It earns its place here and nowhere else on the page: it is the one
 * moment that should stop a scroller, and repeating it would turn a punctuation
 * mark into wallpaper.
 *
 * Blocks sit on an opaque background so the rule appears to pass behind them
 * rather than stopping short, which is what sells the whole thing.
 */
function Rule({ height }) {
  return <YStack width={1} height={height} backgroundColor="$color3" />;
}

export function ConnectorCTA() {
  const isMobile = useIsMobile();

  return (
    <YStack>
      <Container borderTopWidth={1} borderColor="$color3" paddingBottom={isMobile ? '$10' : '$12'}>
        <MotionDiv
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.5 }}
        >
          <YStack alignItems="center">
            <Rule height={isMobile ? 40 : 64} />
            <ConnectorMark size={isMobile ? 44 : 52} />
            <Rule height={isMobile ? 28 : 40} />

            <Eyebrow boxed>Eight products, one platform</Eyebrow>

            <Rule height={isMobile ? 28 : 40} />

            <YStack
              borderWidth={1}
              borderColor="$color3"
              backgroundColor="$background"
              paddingHorizontal={isMobile ? '$5' : '$9'}
              paddingVertical={isMobile ? '$6' : '$8'}
              alignItems="center"
              maxWidth={860}
            >
              <Text
                fontSize={isMobile ? 30 : 46}
                fontWeight="700"
                letterSpacing={-1.6}
                lineHeight={isMobile ? 36 : 52}
                color="$color12"
                textAlign="center"
              >
                Built to outlast the hype cycle.
              </Text>
            </YStack>

            <Rule height={isMobile ? 28 : 40} />

            <XStack gap="$3" flexWrap="wrap" justifyContent="center">
              <Text
                fontSize="$5"
                fontWeight="600"
                color="$color1"
                backgroundColor="$color12"
                paddingHorizontal="$6"
                paddingVertical="$4"
                cursor="pointer"
                hoverStyle={{ opacity: 0.86 }}
                onPress={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
              >
                See the products
              </Text>

              <Text
                fontSize="$5"
                fontWeight="500"
                color="$color11"
                borderWidth={1}
                borderColor="$color3"
                paddingHorizontal="$6"
                paddingVertical="$4"
                cursor="pointer"
                hoverStyle={{ borderColor: '$color5' }}
                onPress={() => { window.location.href = '/about'; }}
              >
                Read the thesis
              </Text>
            </XStack>
          </YStack>
        </MotionDiv>
      </Container>
    </YStack>
  );
}
